import _ from 'underscore';
import { edmCampaign } from '@bingads-webui/edm-campaign';

export const select = [
  'Id',
  'Status',
  'Name',
  'DeliveryStatus',
  'DeliveryStatusDetails',
];

export const expand = [
  'FinalUrls',
];

export const fetchAssetGroupsData = ({
  cid,
  aid,
  campaignId,
  params = {} as Record<string, any>,
}) => edmCampaign
  .Customers.$withKey(cid)
  .Accounts.$withKey(aid)
  .Campaigns.$withKey(campaignId)
  .AssetGroups['Default.GridData']
  .$makeCall({
    query: {
      count: true,
      filter: { where: params.$filter },
      orderby: params.$orderby,
      select: _.union(params.$select || select, params.$expand || expand),
      skip: params.$skip || 0,
      top: params.$top || 20,
    },
  })
  .toPromise();
